import {Injectable} from '@angular/core';
import {KeycloakEventTypeLegacy, KeycloakService} from 'keycloak-angular';
import {BehaviorSubject} from 'rxjs';
import {filter} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  private _authRefreshErrorSubject = new BehaviorSubject<boolean>(false);
  authRefreshError$ = this._authRefreshErrorSubject.asObservable();
  authRefreshError = false;

  constructor(private _keycloakService: KeycloakService) {
    this._routineCheckToken();
  }

  private _routineCheckToken() {
    this._logKeycloakEvents();
    this._handleOnAuthRefreshError();
    this._handleOnTokenExpired();
    this._handleOnAuthRefreshSuccess();
  }

  private _logKeycloakEvents() {
    this._keycloakService.keycloakEvents$.subscribe(event => {
      console.log('keycloakEvents', KeycloakEventTypeLegacy[event?.type]);
    });
  }

  private _handleOnAuthRefreshSuccess() {
    this._keycloakService.keycloakEvents$.pipe(
      filter(event => event.type === KeycloakEventTypeLegacy.OnAuthRefreshSuccess)
    ).subscribe(_ => {
      console.log('Token refresh success')
      this._authRefreshErrorSubject.next(false);
      this.authRefreshError = false;
    });
  }

  private _handleOnTokenExpired() {
    this._keycloakService.keycloakEvents$.pipe(
      filter(event => event.type === KeycloakEventTypeLegacy.OnTokenExpired)
    ).subscribe(async (_) => {
      console.log('Token is expired & refreshs')
      await this._keycloakService.updateToken(-1);
    });
  }

  private _handleOnAuthRefreshError() {
    this._keycloakService.keycloakEvents$.pipe(
      filter(event => event.type === KeycloakEventTypeLegacy.OnAuthRefreshError)
    ).subscribe(_ => {
      console.log('Token refresh error')
      this._authRefreshErrorSubject.next(true);
      this.authRefreshError = true;
    });
  }

  isSuperAdmin(): boolean {
    return this._keycloakService.getUserRoles().findIndex(roles => roles === 'SUPER_ADMIN') > -1;
  }

  logout() {
    this._keycloakService.logout(`${window.location.protocol}//${window.location.host}/`);
  }

  async refreshAccessTokenIfNeeded() {
    console.log('refreshAccessTokenIfNeeded');
    await this._keycloakService.updateToken(30)
      .then(function (refreshed) {
        if (refreshed) {
          console.log('Token was successfully refreshed');
        } else {
          console.log('Token is still valid');
        }
      })
      .catch(() => {
        console.warn('Failed to refresh token. Redirecting to login screen...');
        this._keycloakService.login();
      });
  }

  get email(): string {
    return this._keycloakService.getKeycloakInstance().idTokenParsed?.['email']
  }
}
